import { render } from "./pencil.svg?vue&type=template&id=dbb9048e"
const script = {}
script.render = render

export default script